import { Grid, Link, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../../images/footer-logo.png';
import footerFirstBg from '../../../images/Group 14788.png'
import footerLastBg from '../../../images/Group 14683.png'
import './Footer.css'

const logoBg = {
    backgroundImage: `url(${footerFirstBg})`,
    backgroundBlendMode: 'darken, luminosity',
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    marginLeft: '3%'
}
const contactBg = {
    backgroundImage: `url(${footerLastBg})`,
    backgroundBlendMode: 'darken, luminosity',
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat',
    marginRight: '2%'
}

const Footer = () => {
    return (
        <Box>
            <Grid container spacing={2} id="small-background">
                {/* Footer first column */}
                <Grid item sx={{ textAlign: 'center' }} id="set-background" xs={12} sm={12} md={3}>
                    <Box style={logoBg} sx={{ pt: 3 }}>
                        <NavLink to="/" >
                            <img style={{ width: '192px', paddingTop: '25px' }} src={logo} alt="" />
                        </NavLink>
                        <Box id="display-link">
                            <Typography sx={{ mt: 3, mb: 5 }} style={{ color: '#ffffff', fontSize: '18px' }}>
                                Copyright <i className="far fa-copyright"></i> 2021 Wiz Stack <br />All Rights Reserved
                            </Typography>
                            <Typography sx={{ mt: 2, marginX: 'auto' }} >
                                < Link sx={{ px: 1.3, py: .7, borderRadius: '50%' }} style={{ color: '#000060', margin: '6px', backgroundColor: '#ffffff' }} href="#"><i className="fab fa-facebook-f"></i></ Link>
                                < Link sx={{ px: 1.1, py: .8, borderRadius: '50%' }} style={{ color: '#000060', margin: '6px', backgroundColor: '#ffffff' }} href="#"><i className="fab fa-linkedin-in"></i></ Link>
                                < Link sx={{ px: 1.1, py: .8, borderRadius: '50%' }} style={{ color: '#000060', margin: '6px', backgroundColor: '#ffffff' }} href="#"><i className="fas fa-paper-plane"></i></ Link>
                                < Link sx={{ py: .8, px: 1, borderRadius: '50%' }} style={{ color: '#000060', margin: '6px', backgroundColor: '#ffffff' }} href="#"><i className="fab fa-twitter"></i></ Link>
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item sx={{ textAlign: 'center', py: 2 }} id="set-background-bottom" xs={12} sm={12} md={9}>
                    <Box style={contactBg}>
                        <Grid container sx={{ pt: 3 }} spacing={2}>
                            {/* Footer second column */}
                            <Grid item sx={{ textAlign: 'left' }} xs={6} sm={6} md={4}>
                                <Typography sx={{ m: 1, pb: 2, width: '50%', marginX: 'auto' }} style={{ color: '#ffffff', fontSize: '24px' }} id="set-width" variant="h6" display="block" gutterBottom>
                                    Company
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="/about" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>About Us</NavLink>
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="/services" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Services</NavLink>
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="/trust_us" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Who we Are</NavLink>
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Contact</NavLink>
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Pricing</NavLink>
                                </Typography>
                            </Grid>
                            {/* Footer third column */}
                            <Grid item sx={{ textAlign: 'left' }} xs={6} sm={6} md={4}>
                                <Typography sx={{ m: 1, pb: 2, width: '50%', marginX: 'auto' }} style={{ color: '#ffffff', fontSize: '24px' }} id="set-width" variant="h6" display="block" gutterBottom>
                                    Support
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Help Center</NavLink>
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Legal</NavLink>
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Terms of Service</NavLink>
                                </Typography>
                                <Typography sx={{ m: 1, width: '50%', marginX: 'auto' }} id="set-width">
                                    <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '16px' }}>Privacy Policy</NavLink>
                                </Typography>
                            </Grid>
                            {/* Footer fourth column */}
                            <Grid item sx={{ textAlign: 'left' }} xs={12} sm={6} md={4}>
                                <Typography sx={{ m: 1, pb: 2, width: '75%', marginX: 'auto' }} style={{ color: '#ffffff', fontSize: '24px' }} variant="h6" display="block" gutterBottom>
                                    Reach Us
                                </Typography>
                                <Typography sx={{ m: 1, pl: 3 }} style={{ color: '#f0f0f0' }}>
                                    <i style={{ paddingRight: '10px' }} className="fas fa-envelope"></i> hello@wizstack.com
                                </Typography>
                                <Typography sx={{ mx: 1, my: 3, pl: 3 }} style={{ color: '#f0f0f0' }}>
                                    <i style={{ paddingRight: '10px' }} className="fas fa-mobile-alt"></i> +11 2121212121
                                </Typography>
                                <Typography sx={{ m: 1, pl: 3 }} style={{ color: '#f0f0f0' }}>
                                    <i style={{ paddingRight: '10px' }} className="fas fa-map-marker-alt"></i> 248 Australia Bas <br /><span style={{ paddingLeft: '27px' }}>Havsd, PA 57458</span>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Box sx={{ display: 'none' }} id="small-display">
                            <Typography sx={{ m: 1, width: '75%', marginX: 'auto', pt: 6 }} style={{ color: '#ffffff', fontSize: '24px' }} variant="h6" display="block" gutterBottom>
                                Find us On
                            </Typography>
                            <Typography sx={{ mt: 2, width: '75%', marginX: 'auto' }} >
                                < Link style={{ color: '#ffffff', margin: '10px', fontSize: '30px' }} href="#"><i className="fab fa-dribbble"></i></ Link>
                                < Link style={{ color: '#ffffff', margin: '10px', fontSize: '30px' }} href="#"><i className="fab fa-behance"></i></ Link>
                                < Link style={{ color: '#ffffff', margin: '10px', fontSize: '30px' }} href="#"><i className="fab fa-instagram"></i></ Link>
                            </Typography>
                            <Typography sx={{ my: 2, width: '75%', marginX: 'auto' }} >
                                < Link sx={{ px: 1.3, py: .7, borderRadius: '50%' }} style={{ color: '#000060', margin: '10px', backgroundColor: '#ffffff' }} href="#"><i className="fab fa-facebook-f"></i></ Link>
                                < Link sx={{ px: 1.1, py: .8, borderRadius: '50%' }} style={{ color: '#000060', margin: '10px', backgroundColor: '#ffffff' }} href="#"><i className="fab fa-linkedin-in"></i></ Link>
                                < Link sx={{ px: 1.1, py: .8, borderRadius: '50%' }} style={{ color: '#000060', margin: '10px', backgroundColor: '#ffffff' }} href="#"><i className="fas fa-paper-plane"></i></ Link>
                                < Link sx={{ py: .8, px: 1, borderRadius: '50%' }} style={{ color: '#000060', margin: '10px', backgroundColor: '#ffffff' }} href="#"><i className="fab fa-twitter"></i></ Link>
                            </Typography>
                        </Box>
                        <Typography sx={{ mt: 3, mb: 1 }} id="connect-info" style={{ color: '#ffffff', fontSize: '18px' }}>
                            <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '14px' }}>Terms & Conditions</NavLink> |
                            <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '14px' }}> Privacy Policy</NavLink> |
                            <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '14px' }}> Sitemap</NavLink> |
                            <NavLink to="" style={{ textDecoration: 'none', color: '#f0f0f0', fontSize: '14px' }}> Disclaimer</NavLink>
                        </Typography>
                        <Typography sx={{ display: 'none' }} style={{ color: '#ffffff' }} id="display-copyright">
                            Copyright <i className="far fa-copyright"></i> 2021 Wiz Stack <br />All Rights Reserved
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box >
    );
};

export default Footer;